import React from "react";
import { styled } from "styled-components";
const LoaderContainer = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  svg {
    max-height: 350px !important;
    max-width: 350px !important;
    margin: 0 auto;
  }
`;
export const LottieRenderer = ({ useLottie, animationData, }) => {
    // Clone the animation data to avoid immutability issues
    const clonedAnimationData = { ...animationData };
    const options = {
        animationData: clonedAnimationData,
        loop: true,
    };
    const { View } = useLottie(options);
    return React.createElement(LoaderContainer, null, View);
};
//# sourceMappingURL=LottieRenderer.js.map